export default {
  '[data-maskedinput="date-of-birth"]': {
    alias: 'date'
  },
  '[data-maskedinput="year"]': {
    alias: 'Regex',
    regex: '[0-2][0-9]{3}'
  },
  '[data-maskedinput="postcode"]': {
    alias: 'Regex',
    regex: '[0-9]{4}'
  },
  '[data-maskedinput="letters"]': {
    alias: 'Regex',
    regex: '[a-zA-Zs]*'
  },
  '[data-maskedinput="float"]': {
    alias: 'Regex',
    regex: '[0-9]*[.]?[0-9]*'
  },
  '[data-maskedinput="integer"]': {
    alias: 'Regex',
    regex: '[0-9]*'
  },
  '[data-maskedinput="phone-mobile"]': {
    alias: 'phone',
    mask: '0### ### ###'
  },
  '[data-maskedinput="phone-land"]': {
    alias: 'phone',
    mask: '0# #### ####'
  },
  '[data-maskedinput="phone-land-sp"]': {
    alias: 'phone',
    mask: '## #### ####'
  },
  '[data-maskedinput="time"]': {
    alias: 'hh:mm t'
  },
  '[data-maskedinput="abn"]': {
    mask: '99999999999'
  },
  '[data-maskedinput="brn"]': {
    mask: '999999'
  },
  '[data-maskedinput="currency"]': {
    alias: 'currency',
    prefix: '$ ',
    rightAlign: false,
    allowMinus: false
  }
};



// WEBPACK FOOTER //
// ./src/javascripts/config/inputmask.js